export default "__VITE_ASSET__Bn14Tzyg__"